import * as $ from "jquery";
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { RightSidebarComponent } from './shared/right-sidebar/rightsidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { JwtInterceptor } from './authentication/helper/jwt.interceptor';
import { ErrorInterceptor } from './authentication/helper/error.interceptor';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { AppRoutes } from './app-routing.module';
import { DemoMaterialModule } from './demo-material-module';
import { MenuService } from './shared/sidebar/menu.service';
import { APP_INITIALIZER} from '@angular/core';
import { AuthGuard } from './authentication/guard/auth.guard';
import { AuthenticationService } from './authentication/authentication.service';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SharedModule } from './shared/shared.module';
import { RouteGeneratorService } from "./reports/route-generator.service.service";
import { DataTablesModule } from 'angular-datatables';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ReportsRoute } from "./reports/reports.routing";
import { SummaryComponent } from "./reports/summary/summary.component";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};


export function generateRoutes(): Routes {
  let data=sessionStorage.getItem("Reports");
  let tmp:any;
  const routes:Routes=[];
  if(data!=undefined){
    tmp=JSON.parse(data);
    for(const row of tmp)
      routes.push({path : row.path, data: row.data, component: SummaryComponent})
  }
  else{
    for(const row of ReportsRoute)
      routes.push(row);
  }
  console.log(routes);
  return routes;
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    RightSidebarComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    DemoMaterialModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    SharedModule,
    DataTablesModule,
    NgMultiSelectDropDownModule,
    RouterModule.forRoot(AppRoutes),
  ],
  providers: [
    Title,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthGuard,
    AuthenticationService,
    MenuService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    RouteGeneratorService,
    {
      provide: APP_INITIALIZER,
      useFactory: (routeGeneratorService: RouteGeneratorService) => () => routeGeneratorService.initialize(),
      deps: [RouteGeneratorService],
      multi: true ,
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
